import types from 'constants/actionTypes';

const initialState = null;
const selectedSeriesId = (state, { type, payload }) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (type) {
    case types.SET_SELECTED_SERIES_ID:
      return payload;
    default:
      return state;
  }
};

export default selectedSeriesId;
